import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';

export const authGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const navService = inject(NavigationService);
  const router = inject(Router);  
  
  const expectedRoles = route.data['allowedRoles'];
  let userRole = navService.getUserRole();
  if(userRole === 0){ // user details not saved in local storage
    await navService.getUserInfo();
    userRole = await navService.getUserRole();
  }

  if (expectedRoles.includes(userRole)) {
    return true;
  } else {
    router.navigate(['/distribution']);
    return false;
  }
};
